import script from "./SelectorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectorPage.vue?vue&type=script&setup=true&lang=js"

import "./SelectorPage.vue?vue&type=style&index=0&id=857db4da&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-857db4da"]])

export default __exports__